export default "<spec-app-type1-base-table #table [clickHandler]=\"clickHandler\" [allowCreate]=\"true\"></spec-app-type1-base-table>\n";